export default {
    slug: 'support',
    ability: 'support',
    routes: [
        {
            path: 'support/tickets',
            name: 'ticket-list',
            component: () => import('@modules/Support/Resources/js/pages/support/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'ticket-preview',
                    component: () => import('@modules/Support/Resources/js/pages/support/Preview.vue'),
                    redirect: { name: 'ticket-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/support/tickets/:id(\\d+)',
                            name: 'ticket-overview',
                            component: () => import('@modules/Support/Resources/js/pages/support/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'ticket-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'ticket-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'support/knowledge-base',
            name: 'support-kb',
            component: () => import('@modules/Support/Resources/js/pages/support/KnowledgeBase.vue')
        },
        {
            path: 'support/knowledge-base/articles/:id(\\d+)',
            name: 'support-kb-article',
            component: () => import('@modules/Support/Resources/js/pages/support/KBArticleDetail.vue'),
            props: true
        },
        {
            path: 'support/sla-policies',
            name: 'support-sla-policies',
            component: () => import('@modules/Support/Resources/js/pages/support/SLAPolicies.vue')
        },
        {
            path: 'support/canned-responses',
            name: 'support-canned-responses',
            component: () => import('@modules/Support/Resources/js/pages/support/CannedResponses.vue')
        },
        {
            path: 'support/services',
            name: 'support-services',
            component: () => import('@modules/Support/Resources/js/pages/support/Services.vue')
        }
    ],
    widgets: () => [
        {
            id: 'support-overview',
            label: i18n.t('Support Overview'),
            icon: 'lifebuoy',
            component: () => import('@modules/Support/Resources/js/pages/support/widgets/SupportOverview.vue'),
            size: 'is-6'
        },
        {
            id: 'support-tickets-by-status',
            label: i18n.t('Tickets by Status'),
            icon: 'ticket-confirmation-outline',
            component: () => import('@modules/Support/Resources/js/pages/support/widgets/SupportTicketsByStatus.vue'),
            size: 'is-4'
        },
        {
            id: 'support-volume-trend',
            label: i18n.t('Ticket Volume Trend'),
            icon: 'chart-timeline-variant',
            component: () => import('@modules/Support/Resources/js/pages/support/widgets/SupportVolumeTrend.vue'),
            size: 'is-6'
        }
    ],
    portalRoutes: [
        {
            path: 'tickets',
            name: 'portal-tickets',
            component: () => import('@modules/Support/Resources/js/portal/Tickets.vue')
        },
        {
            path: 'tickets/:id(\\d+)',
            name: 'portal-ticket-detail',
            component: () => import('@modules/Support/Resources/js/portal/TicketDetail.vue'),
            props: true
        },
        {
            path: 'knowledge-base',
            name: 'portal-kb',
            component: () => import('@modules/Support/Resources/js/portal/KnowledgeBase.vue')
        },
        {
            path: 'knowledge-base/:id(\\d+)',
            name: 'portal-kb-article',
            component: () => import('@modules/Support/Resources/js/portal/KBArticle.vue'),
            props: true
        }
    ],
    nav: () => ({
        section: 'support',
        items: [
            { title: i18n.t('Tickets'), icon: 'ticket-outline', to: { name: 'ticket-list' } },
            { title: i18n.t('Knowledge Base'), icon: 'book-open-variant', to: { name: 'support-kb' } },
            { title: i18n.t('SLA Policies'), icon: 'clock-alert-outline', to: { name: 'support-sla-policies' } },
            { title: i18n.t('Canned Responses'), icon: 'text-box-outline', to: { name: 'support-canned-responses' } },
            { title: i18n.t('Services'), icon: 'cog-outline', to: { name: 'support-services' } }
        ]
    })
};
